

































































import { Vue, Component, Prop } from 'vue-property-decorator';
import AMSformTable from '../../../components/AMSformTable.vue';
import AMSProduct from '../../../components/AMSProductCategorySelector.vue';
import AMSProductImg from '../../../components/AMSProductImg.vue';
import AMSDialog from '@/components/AMSDialog.vue';
import { AppStore } from '@/store/modules/app';
import request from '@/utils/request';
import Utils from '@/utils/utils';
import AMSBrandSelector from '@/components/AMSBrandSelector.vue';
import AMSBreadcrumb from '@/components/AMSBreadcrumb.vue';
import { getModuleName } from '@/utils/utils';
import moment from 'moment';
import { updateProductionDate } from '@/api/stock';
interface Form {
  productFilter?: string;
  productCategoryId?: string;
  brandId?: string;
  productionDateType?: string;
  productionDate?: string;
}
@Component({
  components: {
    'ams-formtable': AMSformTable,
    'ams-product': AMSProduct,
    'ams-brand-selector': AMSBrandSelector,
    'ams-breadcrumb': AMSBreadcrumb,
    'ams-dialog': AMSDialog
  }
})
export default class ProductionDateStock extends Vue {
  breadcrumbsItems = [
    {
      text: '商品库存',
      disabled: false,
      href: '/productStock'
    },
    {
      text: '有效期查询',
      disabled: true
    }
  ];
  showUpdateDateDialog: boolean = false;
  selectId: string = '';
  productionDate: string = new Date().toISOString().substr(0, 10);
  api: string = '/api/stock/productionDateList';
  rules = { name: [] };
  form: Form = {};
  initForm() {
    this.form = { brandId: '', productFilter: '' };
  }
  beforeQuery() {
    let now = new Date();
    let queryDate = now;
    switch (this.form.productionDateType) {
      case 'twoYear':
        queryDate.setMonth(queryDate.getMonth() + 24);
        this.form.productionDate = moment(queryDate).format('YYYY-MM-DD');
        break;
      case 'oneYear':
        queryDate.setMonth(queryDate.getMonth() + 12);
        this.form.productionDate = moment(queryDate).format('YYYY-MM-DD');
        break;
      case 'oneHalfYear':
        queryDate.setMonth(queryDate.getMonth() + 18);
        this.form.productionDate = moment(queryDate).format('YYYY-MM-DD');
        break;
      case 'halfYear':
        queryDate.setMonth(queryDate.getMonth() + 6);
        this.form.productionDate = moment(queryDate).format('YYYY-MM-DD');
        break;
    }
    console.log(this.form.productFilter);
  }
  categoryList: Array<any> = [];
  productionDateQueryType = [{ value: 'twoYear', text: '2年' }, { value: 'oneYear', text: '1年' }, { value: 'oneHalfYear', text: '1年半' }, { value: 'halfYear', text: '半年' }];
  headers = [
    // { text: '编号', value: 'serialNumber', sortable: false, width: 100, align: 'left' },
    {
      text: '商品',
      value: 'name',
      sortable: false,
      render: (h: Function, param: any) => {
        return h(AMSProductImg, {
          props: {
            isShowNumber: true,
            product: param.row.product,
            pictureWidth: 40,
            pictureHeight: 40
          }
        });
      },
      width: 100,
      align: 'left'
    },
    { text: '容量', value: 'capacity', width: 90, align: 'right' },
    { text: '限用日期', value: 'productionDate', width: 120, align: 'center', isFormatDate: true },
    {
      text: '库存数',
      value: 'stockQuantity',
      width: 160,
      align: 'right'
    },
    {
      text: '未发货数',
      value: 'lockedStockQuantity',
      width: 140,
      align: 'right'
    },
    {
      text: '操作',
      value: 'actions',
      align: 'center',
      isDetail: [
        {
          callBack: (btn: any, row: any, key: string) => {
            this.confirmItem(btn, row, key, 'updateDate');
          },
          text: '修改日期',
          color: '#1ABC9C',
          isShowBtn: (row: any) => {
            return Utils.isPermission('InventoryManager.ProductionDate.Update');
          }
        }
      ],
      width: 270
    }
  ];
  created() {
    // this.initForm();
    if (JSON.parse(localStorage.getItem(`${getModuleName(this.$route.name as string)}_search`) as string)) {
      this.form = JSON.parse(localStorage.getItem(`${getModuleName(this.$route.name as string)}_search`) as string);
    }
  }
  confirmItem(btn: any, row: any, key: string, type?: string, val?: any) {
    if (type === 'updateDate') {
      this.productionDate = this.formatDate(row.item.productionDate, 'YYYY-MM-DD');
      this.selectId = row.item.id;
      this.showUpdateDateDialog = true;
    }
  }
  formatDate(date: string, type: string) {
    return moment(date).format(type);
  }
  confirmUpdateDateDialog() {
    if ((this.$refs.rechargeForm as any).validate()) {
      const params = {
        productionDate: moment(this.productionDate).format('YYYY-MM-DD')
      };
      updateProductionDate(this.selectId, params)
        .then((response: any) => {
          AppStore.ShowSuccess('修改成功');
          this.showUpdateDateDialog = false;
          (this.$refs.formtable as HTMLFormElement).query();
        })
        .catch((err: any) => {
          AppStore.ShowError(err.response.data.error.message);
          (this.$refs.formtable as HTMLFormElement).query();
        });
    }
  }
}
